module.exports = __webpack_public_path__ + "static/img/down_btn11.376060e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cec2022/down_btn11.png
// module id = KHYn
// module chunks = 4